import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import "./ChefGrid.css";
import PLACEHOLDER from "../assets/images/placeholders/chef2table_placeholder.png";

export default function ChefGrid({ chefs = [] }) {
  const [isChanging, setIsChanging] = useState(false);
  const [displayedChefs, setDisplayedChefs] = useState(chefs);

  useEffect(() => {
    if (JSON.stringify(chefs) === JSON.stringify(displayedChefs)) {
      return;
    }
    
    // Start transition
    setIsChanging(true);
    
    // After old content fades out, update with new content
    const timer = setTimeout(() => {
      setDisplayedChefs(chefs);
      setIsChanging(false);
    }, 450); // Half of the total animation time

    return () => clearTimeout(timer);
  }, [chefs, displayedChefs]);

  return (
    <div className="chef-grid" role="list">
      {displayedChefs.map((chef, index) => {
        const src = chef.photo_url || chef.photoUrl || chef.imageUrl || chef.image || chef.img || PLACEHOLDER;
        const name = chef.name || "Chef";
        const city = chef.city || "";
        
        // Build query parameters for ChefDemo page
        const queryParams = new URLSearchParams();
        if (chef.id) queryParams.set('id', chef.id);
        if (chef.name) queryParams.set('name', chef.name);
        if (src && src !== PLACEHOLDER) queryParams.set('photo', src);
        if (chef.specialties) queryParams.set('specialties', chef.specialties);
        if (chef.data_source) queryParams.set('data_source', chef.data_source);

        const demoUrl = `/chef-demo/${city.toLowerCase() || 'toronto'}?${queryParams.toString()}`;

        return (
          <Link 
            to={demoUrl}
            className={`chef-card ${isChanging ? 'shuffle-exit' : ''}`}
            role="listitem" 
            key={`chef-${chef.id || name || index}`}
            onClick={() => console.log('Chef card clicked:', { name, city, demoUrl })}
          >
            <div className="chef-card-thumb">
              <img
                className="chef-card-img"
                src={src}
                alt={`${name}${city ? ` — ${city}` : ""}`}
                loading="lazy"
                decoding="async"
                onLoad={(e) => console.log(`Image loaded for ${name}:`, {
                  naturalWidth: e.target.naturalWidth,
                  naturalHeight: e.target.naturalHeight,
                  src: src,
                  dataSource: chef.data_source
                })}
              />
            </div>
            <div className="chef-card-info">
              <h3 className="chef-name">{name}</h3>
              {city && <div className="chef-city">{city}</div>}
              {chef.data_source === 'real' && (
                <div className="chef-badge">Real Chef</div>
              )}
            </div>
          </Link>
        );
      })}
    </div>
  );
}